/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Debtor_DescriptionInputs */

const en_case_section_debtor_description = /** @type {(inputs: Case_Section_Debtor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individual or company responsible for the debt.`)
};

const pt_br2_case_section_debtor_description = /** @type {(inputs: Case_Section_Debtor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pessoa física ou jurídica responsável pela dívida.`)
};

/**
* | output |
* | --- |
* | "Individual or company responsible for the debt." |
*
* @param {Case_Section_Debtor_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_debtor_description = /** @type {((inputs?: Case_Section_Debtor_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Debtor_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_debtor_description(inputs)
	return pt_br2_case_section_debtor_description(inputs)
});